import React from "react"
import { css } from "@emotion/core"
import TabMenu from "components/UI/TabMenu"
import DropdownMenu from "components/UI/DropdownMenu"
import t, { mixin } from "theme"

const DesktopFeatureSelector = ({ commonData, selectedCompany, selectedFeature }) => {
    const companyFeatures =
        selectedCompany &&
        commonData.featureDatabase.find(el => el.ticker.toLowerCase() === selectedCompany.ticker.toLowerCase()).features

    return (
        selectedCompany && (
            <TabMenu
                css={css`
                    font-size: ${t.font.size[3]};
                `}
                choices={companyFeatures}
                selected={selectedFeature}
            />
        )
    )
}

//mobile features
const MobileFeatureSelector = ({ commonData, selectedCompany, selectedFeature }) => {
    const companyFeatures =
        selectedCompany &&
        commonData.featureDatabase.find(el => el.ticker.toLowerCase() === selectedCompany.ticker.toLowerCase()).features

    return (
        selectedCompany && (
            <DropdownMenu
                selected={selectedFeature}
                choices={companyFeatures}
                css={css`
                    width: auto;
                    font-size: ${t.font.size[3]};
                    ${mixin.phonestyle} {
                        width: 35vw;
                    }
                `}
            />
        )
    )
}

export { DesktopFeatureSelector, MobileFeatureSelector }
